import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=300a05a4&scoped=true&"
import script from "./ItemTable.vue?vue&type=script&lang=ts&"
export * from "./ItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./ItemTable.vue?vue&type=style&index=0&id=300a05a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300a05a4",
  null
  
)

export default component.exports